import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    conversationHistory: [],
    conversationId: undefined,
    employeeList: [
        {
          id: 1,
          icon: "/images/AI员工图标/知识产权部门/软著专员.png",
          name: "软著专员",
          departmentId: 1,
          description:
            "一站式 AI 自动合规校验、自主提交、全程代办软著登记。",
          author: "躬身科技",
          views: "33.5万",
          shopId: 10,
          shopName: '计算机软件著作权店铺',
          greeting: `您好！我是软著专员😃
专注软件著作权全流程服务，可帮您智能核验软著申请材料、整理说明书与代码文档、解答软著办理流程、材料规范及进度咨询。
一站式简化软著申报，省时省心，有任何需求尽管告诉我！`

        },
        {
          id: 2,
          icon: "/images/AI员工图标/知识产权部门/商标专员.png",
          name: "商标专员",
          departmentId: 1,
          description:
            "集商标查询、近似比对、风险评估、起名设计及注册材料智能核验于一体的全流程 AI 知识产权服务。",
          author: "躬身科技",
          views: "33.5万",
          shopId: 11,
          shopName: '商标店铺',
          greeting: `您好！我是商标专员😃
专注商标查询、品牌起名、注册流程咨询、驳回异议文书撰写、品牌布局风险评估全流程服务。AI 赋能商标业务，一站式守护品牌知识产权，有任何商标需求随时告诉我！`
        },
        {
          id: 3,
          icon: "/images/AI员工图标/知识产权部门/专利专员.png",
          name: "专利专员",
          departmentId: 1,
          description:
            "集专利检索、新颖性评估、技术方案梳理、专利文案智能核验与申报流程指引于一体的全流程 AI 专利服务。",
          author: "深圳抖尘",
          views: "33.5万",
          shopId: 14,
          shopName: '专利店铺',
          greeting: `您好！我是专利专员😃
专注专利检索、专利挖掘、交底书撰写、申请流程答疑、专利布局及驳回答复文书指导，AI 赋能专利全流程服务，助力技术成果知识产权保护，有任何专利需求都可随时咨询。`
        },

        {
          id: 4,
          icon: "/images/AI员工图标/知识产权部门/版权专员.png",
          name: "版权专员",
          departmentId: 1,
          description:
            "集作品版权登记、权属存证、侵权监测、合规审核与申报材料智能核验于一体的全链路 AI 版权服务。",
          author: "躬身科技",
          views: "33.5万",
          shopId: 12,
          shopName: '版权店铺',
          greeting: `您好！我是版权专员😃
专注作品版权登记、文案美术作品确权、版权流程答疑、材料整理、侵权维权咨询，AI 赋能版权全流程服务，全方位守护原创作品知识产权，有任何版权需求均可随时咨询。`
        },

        {
          id: 6,
          icon: "/images/AI员工图标/资质政策部/平台上架专员.png",
          name: "平台上架专员",
          departmentId: 3,
          description:
            "专注网站备案、APP 上架、网络安全评估报告全流程代办。整合线上业务办理、资质申报、流程代办、信息咨询与合规指引于一体的一站式 AI 企业互联网综合服务。",
          author: "抖尘科技",
          views: "15.8万",
          shopId: 16,
          shopName: '互联网服务店铺',
          greeting: `您好！我是平台上架专员😃
专注网站备案、小程序开发、线上资质办理、互联网业务合规咨询与平台搭建指引，AI 赋能互联网全流程服务，助力企业线上化经营，有相关需求均可随时咨询。`
        },
        {
          id: 7,
          icon: "/images/AI员工图标/工商财税部/国际商标专员.png",
          name: "国际商标专员",
          departmentId: 2,
          description:
            "涵盖全球商标检索、国别风险评估、注册方案规划、多国申报材料智能核验及国际商标流程一站式指引的 AI 服务。",
          author: "躬身科技",
          views: "12.3万",
          shopId: 17,
          shopName: '国际商标店铺',
          greeting: `您好！我是国际商标专员😃
专注全球商标注册、马德里体系申请、各国商标检索、海外品牌布局、注册流程答疑与风险评估，AI 赋能跨境商标全流程服务，全方位护航企业全球化品牌发展，有任何国际商标需求均可随时咨询。`
        },
        {
          id: 8,
          icon: "/images/AI员工图标/工商财税部/国际工商专员.png",
          name: "国际工商专员",
          departmentId: 2,
          description:
            "覆盖全球各地海外公司注册全品类工商业务，一站式线上标准化流程，资料简化提交、全程代办跟进。集海外公司注册、年审维护、合规备案、属地政策解读与跨境工商材料智能整合于一体的全球化企业工商 AI 服务。",
          author: "躬身科技",
          views: "8.6万",
          shopId: 18,
          shopName: '国际工商店铺',
          greeting: `您好！我是国际工商专员😃
专注海外公司注册、多国工商年审、离岸主体搭建、跨境企业合规、海外财税及签证开户咨询，AI 赋能国际工商全流程服务，助力企业全球化布局与跨境经营，各类国际工商需求均可随时咨询。`
        },
        {
          id: 9,
          icon: "/images/AI员工图标/人事行政部/行政专员.png",
          name: "GEO 获客专员",
          departmentId: 5,
          description:
            "帮您管控销售过程、防止客户流失，提升销售业绩",
          author: "躬身科技",
          views: "12.3万",
          shopId: 21,
          shopName: 'AI工作手机店',
          greeting: `您好！我是您的GEO 获客专员 🎯
专注帮 OPC / 中小企业精准定位本地潜在客户，高效拓展业务渠道～
您可以直接咨询获客问题（比如 “帮我找重庆的餐饮商家”），也可以点击下方链接了解 GEO 产品详情
 <a target="_blank" rel="noopener noreferrer" href="https://www.evodust.com/geo">https://www.evodust.com/geo</a>
</a>
`
        },
        {
          id: 10,
          icon: "/images/AI员工图标/人事行政部/行政专员.png",
          name: "AI 手机专员",
          departmentId: 5,
          description:
            "帮您管控销售过程、防止客户流失，提升销售业绩",
          author: "抖尘云",
          views: "12.3万",
          shopId: 15,
          shopName: 'GEO营销推广店',
          greeting: `您好！我是您的AI 手机专员 📱
专注解决传统 CRM「数据失真、过程失控、客户流失」痛点，帮您管好销售全流程～
您可以直接咨询销售管理问题（比如 “怎么监控员工微信沟通”），也可以点击下方卡片了解 AI 手机产品详情👇
 <a target="_blank" rel="noopener noreferrer" href="https://www.evodust.com/ai-phone">https://www.evodust.com/ai-phone</a>

`

        },
        {
          id: 11,
          icon: "/images/AI员工图标/人事行政部/行政专员.png",
          name: "OPC社区智能体",
          departmentId: 4,
          description:
            "专注一人公司（OPC）工商财税、知识产权全流程服务",
          author: "躬身科技",
          views: "12.3万",
          shopId: 22,
          shopName: '工商财税店铺',
          greeting: `欢迎使用 OPC 社区智能体！专注 OPC 一人公司全链路服务，涵盖工商注册、财税打理、税务统筹及知识产权一站式办理，流程清晰、专业合规，全力助力个人独资企业高效落地稳健运营。`
        },
        {
          id: 12,
          icon: "/images/AI员工图标/工商财税部/审计专员.png",
          name: "审计专员",
          departmentId: 2,
          description:
            "专注企业内部审计、财务稽核与合规风控，助力快速梳理审计流程、撰写底稿报告、排查账务及合规隐患，高效完成各类审计事务处理。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 13,
          icon: "/images/AI员工图标/工商财税部/评估专员.png",
          name: "评估专员",
          departmentId: 2,
          description:
            "专注资产评估、知识产权估值与项目价值研判，可梳理评估流程、整理备案资料、出具专业文案，高效协助完成各类评估业务办理。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 14,
          icon: "/images/AI员工图标/工商财税部/验资专员.png",
          name: "验资专员",
          departmentId: 2,
          description:
            "专注企业注册资本实缴、增资减资及招投标验资全流程，梳理办理流程、整理备案资料、起草相关文书，高效合规办结各类验资业务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 15,
          icon: "/images/AI员工图标/工商财税部/工商专员.png",
          name: "工商专员",
          departmentId: 2,
          description:
            "专注公司注册、变更注销、股权调整及年报公示等全量工商业务，梳理办事流程、规整申报材料、提供规范文案模板，一站式高效办理各类工商事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 16,
          icon: "/images/AI员工图标/工商财税部/社保公积金专员.png",
          name: "社保公积金专员",
          departmentId: 2,
          description:
            "专注企业社保增减员、基数调整、公积金开户缴存及转移提取等全流程业务，梳理办事流程、整理申报资料、提供规范文案指引，高效经办人事社保公积金各类事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 17,
          icon: "/images/AI员工图标/工商财税部/财税专员.png",
          name: "财税专员",
          departmentId: 2,
          description:
            "专注企业记账报税、税务申报、发票管理、财税合规与税务筹划，解读财税政策、梳理办税流程、规避税务风险，一站式处理企业全维度财税事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 18,
          icon: "/images/AI员工图标/工商财税部/记账专员.png",
          name: "记账专员",
          departmentId: 2,
          description:
            "专注企业凭证编制、账务登记、费用核对与往来账整理，规范做账流程、规整票据台账，高效处理企业日常全盘记账与账务梳理工作。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 19,
          icon: "/images/AI员工图标/工商财税部/发票专员.png",
          name: "发票专员",
          departmentId: 2,
          description:
            "专注企业发票申领、开具红冲、进项认证及票据台账管理，规范开票流程、审核票据合规性，一站式高效处理全品类发票管理事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 20,
          icon: "/images/AI员工图标/资质政策部/实缴专员.png",
          name: "实缴专员",
          departmentId: 3,
          description:
            "专注企业注册资本新设、增资、股权及招投标实缴业务，梳理办理流程、整理备案材料、规范资金文书，合规高效办结各类实缴事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 21,
          icon: "/images/AI员工图标/资质政策部/高企专员.png",
          name: "高企专员",
          departmentId: 3,
          description:
            "专注高新技术企业申报、培育入库、复审维护与研发费用归集，精准匹配申报条件、编制申报材料、把控科创指标，全方位助力高企认定高效通关。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 22,
          icon: "/images/AI员工图标/资质政策部/专精特新专员.png",
          name: "专精特新专员",
          departmentId: 3,
          description:
            "专注各级专精特新企业培育、入库申报、认定复审与材料编撰，精准对标申报指标、梳理科创财务资料，助力企业快速通过资质认定。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 23,
          icon: "/images/AI员工图标/资质政策部/小巨人专员.png",
          name: "小巨人专员",
          departmentId: 3,
          description:
            "专注国家级专精特新小巨人企业梯度培育、申报认定、复审维护与全套材料编制，精准对标评审指标，助力企业晋级拿证与资质存续。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 24,
          icon: "/images/AI员工图标/资质政策部/资质专员.png",
          name: "资质专员",
          departmentId: 3,
          description:
            "专注企业行业许可、体系认证、经营资质及荣誉资质新办升级年审，梳理申报条件、编撰全套材料、把控合规要点，一站式代办各类企业资质事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 25,
          icon: "/images/AI员工图标/资质政策部/补贴专员.png",
          name: "补贴专员",
          departmentId: 3,
          description:
            "专注各类政府科创、人才、稳岗等政策补贴解读、项目匹配与申报材料撰写，精准梳理申报条件、规避申报短板，助力企业高效申领政策红利。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 26,
          icon: "/images/AI员工图标/获客销售部/短视频获客专员.png",
          name: "短视频获客专员",
          departmentId: 4,
          description:
            "专注短视频账号定位、脚本创作、文案策划、流量运营与意向客户引流转化，一站式助力企业通过短视频高效精准获客。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 27,
          icon: "/images/AI员工图标/获客销售部/私域获客专员.png",
          name: "私域获客专员",
          departmentId: 4,
          description:
            "专注私域流量引流、用户沉淀、社群运营及客户精细化维护转化，全流程助力企业低成本精准拓客、锁客和持续变现。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 28,
          icon: "/images/AI员工图标/获客销售部/电商运营专员.png",
          name: "电商运营专员",
          departmentId: 4,
          description:
            "专注店铺装修、商品上架、标题优化、活动策划、流量推广及订单复盘，全链路打理电商店铺运营，精准引流提升销量与转化。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 29,
          icon: "/images/AI员工图标/获客销售部/销售话术专员.png",
          name: "销售话术专员",
          departmentId: 4,
          description:
            "可量身定制各行业开场、逼单、异议处理及成交全流程话术，适配不同客户场景快速输出专业话术，助力销售高效沟通、提升成交率。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 30,
          icon: "/images/AI员工图标/获客销售部/品牌宣传专员.png",
          name: "品牌宣传专员",
          departmentId: 4,
          description:
            "专注品牌文案创作、宣传内容策划、形象包装及口碑推广，适配多平台传播场景，全方位打造品牌影响力、提升企业知名度。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 31,
          icon: "/images/AI员工图标/获客销售部/活动引流专员.png",
          name: "活动引流专员",
          departmentId: 4,
          description:
            "专注线上线下活动策划、流程方案撰写、引流玩法设计和宣传文案输出，快速聚拢人气、裂变获客并提升活动转化效果。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 32,
          icon: "/images/AI员工图标/品牌销售部/新媒体专员.png",
          name: "新媒体专员",
          departmentId: 5,
          description:
            "专注公众号、小红书、抖音等多平台内容策划、文案创作、排版发布与账号运营，精准打造内容流量，助力品牌涨粉引流与曝光转化。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 33,
          icon: "/images/AI员工图标/品牌销售部/营销专员.png",
          name: "营销专员",
          departmentId: 5,
          description:
            "全渠道负责营销方案策划、推广文案创作、活动落地及客户引流转化，精准挖掘市场需求，助力企业拓客增收、提升品牌销量与市场影响力。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 34,
          icon: "/images/AI员工图标/品牌销售部/设计专员.png",
          name: "设计专员",
          departmentId: 5,
          description:
            "专注海报、LOGO、宣传物料及办公视觉素材创意设计，适配多风格排版构图，高效输出合规美观的视觉作品，满足品牌宣传与业务物料各类设计需求。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 35,
          icon: "/images/AI员工图标/品牌销售部/品牌专员.png",
          name: "品牌专员",
          departmentId: 5,
          description:
            "专注品牌形象塑造、品牌文案撰写、口碑维护与全渠道宣传推广，统筹品牌传播与调性打造，持续提升企业品牌知名度、美誉度与市场竞争力。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 36,
          icon: "/images/AI员工图标/法务合规部/合同专员.png",
          name: "合同专员",
          departmentId: 6,
          description:
            "专注各类合同模板拟定、条款审核、风险排查、内容修改及合规校对，高效把控合同法律风险，助力企业标准化、规范化处理全品类合同事务。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 37,
          icon: "/images/AI员工图标/法务合规部/合规专员.png",
          name: "合规专员",
          departmentId: 6,
          description:
            "专注企业经营全流程合规审查、风险排查、制度梳理及合规文案拟定，实时把控业务法律与行业规范底线，助力企业稳健合规经营。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 38,
          icon: "/images/AI员工图标/法务合规部/劳动专员.png",
          name: "劳动专员",
          departmentId: 6,
          description:
            "专注劳动合同拟定、人事制度梳理、劳资纠纷咨询、用工风险排查，规范企业人事用工流程，规避劳动合规风险。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 39,
          icon: "/images/AI员工图标/人事行政部/人事专员.png",
          name: "人事专员",
          departmentId: 7,
          description:
            "专注招聘邀约、入职离职办理、考勤薪酬核算、人事制度梳理及员工档案管理，全流程数字化打理人事日常事务，高效规范企业人力资源管理。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 40,
          icon: "/images/AI员工图标/人事行政部/行政专员.png",
          name: "行政专员",
          departmentId: 7,
          description:
            "专注企业日常行政事务、规章制度拟定、办公物资管理、会务接待及后勤统筹，标准化落地行政流程，高效保障企业日常有序运转。",
          author: "",
          views: "",
          shopId: null,
          shopName: ''
        },
        {
          id: 41,
          icon: "/images/AI员工图标/人事行政部/行政专员.png",
          name: "营销获客智能体",
          departmentId: 4,
          description:
            "AI 驱动多平台获客、矩阵运营与智能销售，一站式搞定品牌推广与客户转化",
          author: "",
          views: "",
          shopId: '无',
          shopName: ''
        },




      ]


  },
  mutations: {
    SET_CONVERSATION_HISTORY(state, history) {
      state.conversationHistory = history
    },
    SET_CONVERSATION_ID(state, id) {
      state.conversationId = id
    }
  },
  actions: {
    setConversationHistory({ commit }, history) {
      commit('SET_CONVERSATION_HISTORY', history)
    },
    conversationId({ commit }, id) {
      commit('SET_CONVERSATION_ID', id)

    }
  
  },
  getters: {
    conversationHistory: state => state.conversationHistory,
    conversationId: state => state.conversationId,
    employeeList: state => state.employeeList
  }
})